import React from "react";
import { Search, X } from "lucide-react";
import { cn } from "../../lib/utils";

interface MobileSearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

const MobileSearchField: React.FC<MobileSearchFieldProps> = ({
  value,
  onChange,
  placeholder,
  disabled,
  className,
}) => (
  <div className={cn("relative w-full", className)}>
    <Search className="pointer-events-none absolute left-3.5 top-1/2 h-[18px] w-[18px] -translate-y-1/2 text-gray-400" />
    <input
      type="search"
      inputMode="search"
      enterKeyHint="search"
      value={value}
      placeholder={placeholder}
      disabled={disabled}
      onChange={(event) => onChange(event.target.value)}
      className="h-11 w-full rounded-xl border-0 bg-white pl-10 pr-10 text-[15px] text-gray-900 shadow-[0_1px_2px_rgba(13,14,19,0.04)] ring-1 ring-gray-100 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 [&::-webkit-search-cancel-button]:hidden"
    />
    {value && (
      <button
        type="button"
        onClick={() => onChange("")}
        aria-label="Clear search"
        className="absolute right-2 top-1/2 flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-full border-0 bg-gray-100 p-0 text-gray-500 active:bg-gray-200"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    )}
  </div>
);

export default MobileSearchField;
